/* Native disclosures remain usable without JS. Preserve mobile choices across breakpoint changes. */
(() => {
  if (window.saberFooterInitialized) return;
  window.saberFooterInitialized = true;
  const desktop = window.matchMedia("(min-width: 990px)");
  const navigations = new Map();
  function initialize(root = document) {
    const groups = [...root.querySelectorAll("saber-footer-nav")];
    if (root.matches?.("saber-footer-nav")) groups.unshift(root);
    groups.forEach((navigation) => {
      if (navigations.has(navigation)) return;
      const panels = [...navigation.querySelectorAll(".ss-foot-group")];
      const mobileOpen = new Map(panels.map((panel) => [panel, false]));
      panels.forEach((panel) => {
        panel.open = desktop.matches;
      });
      navigations.set(navigation, { panels, mobileOpen });
    });
  }
  desktop.addEventListener("change", (event) => {
    navigations.forEach((state, navigation) => {
      if (!navigation.isConnected) {
        navigations.delete(navigation);
        return;
      }
      state.panels.forEach((panel) => {
        if (event.matches) {
          state.mobileOpen.set(panel, panel.open);
          panel.open = true;
        } else panel.open = state.mobileOpen.get(panel);
      });
    });
  });
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", () => initialize(), {
      once: true,
    });
  else initialize();
  document.addEventListener("shopify:section:load", (event) =>
    initialize(event.target),
  );
})();
